import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ErrorIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path
        d="M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M11,8 C11,7.44771525 11.4477153,7 12,7 C12.5522847,7 13,7.44771525 13,8 L13,12 C13,12.5522847 12.5522847,13 12,13 C11.4477153,13 11,12.5522847 11,12 L11,8 Z M11.2928932,15.7071068 C10.9023689,15.3165825 10.9023689,14.6834175 11.2928932,14.2928932 C11.6834175,13.9023689 12.3165825,13.9023689 12.7071068,14.2928932 C13.0976311,14.6834175 13.0976311,15.3165825 12.7071068,15.7071068 C12.3165825,16.0976311 11.6834175,16.0976311 11.2928932,15.7071068 Z"
        id="path-1"
      />
    </g>
  </SvgIcon>
);

export default ErrorIcon;
